import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appAlphaNumeric]'
})
export class AlphaNumericDirective {
  regexStr = '^[a-zA-Z0-9-]*$';
  regExNum = '^[0-9]+$';
  @Input() isAlphaNumeric: boolean;
  @Input() isNumber: boolean;
  
  constructor(private el: ElementRef) { }

  // @HostListener('keypress', ['$event']) onKeyPress(event) {
  //   return new RegExp(this.regexStr).test(event.key);
  // }

  @HostListener('keypress', ['$event']) onKeyPress(event) {
    return new RegExp(this.regExNum).test(event.key);
  }

}
